import { schema } from 'normalizr';
import merge from 'lodash/merge';
import { LocalizableString } from '../common/types';
import { mapLocalizable } from '../common/utils';

export interface BoothTaxonomy {
  id: string;
  name: LocalizableString;
  subcategories?: BoothTaxonomy[];
  parentSupercategory?: BoothTaxonomy[];
}

export const boothTaxonomyEntity = new schema.Entity('boothTaxonomies', {}, {
  mergeStrategy(first, second) {
    return merge(first, mapLocalizable(second));
  },
  processStrategy(entity) {
    return mapLocalizable(entity);
  },
});
